import type { DragEvent } from "react";
import { useWorldStore } from "../../stores/world.js";

const AGENT_TEMPLATES = [
  {
    backend: "claude-agent-sdk",
    label: "Claude Agent",
    description: "Anthropic Claude via Agent SDK",
    model: "sonnet",
    color: "border-l-brand-purple",
  },
  {
    backend: "openai-agents",
    label: "OpenAI Agent",
    description: "OpenAI via Assistants API",
    model: "gpt-4o",
    color: "border-l-brand-green",
  },
  {
    backend: "cloudflare-agents",
    label: "CF Agent",
    description: "Cloudflare Agents (Durable Objects)",
    model: "default",
    color: "border-l-brand-pink",
  },
  {
    backend: "raw-api",
    label: "Raw API Agent",
    description: "Direct API calls",
    model: "default",
    color: "border-l-brand-cyan",
  },
];

export function AgentPalette() {
  const mode = useWorldStore((s) => s.mode);

  if (mode !== "design") return null;

  const onDragStart = (event: DragEvent, template: (typeof AGENT_TEMPLATES)[0]) => {
    event.dataTransfer.setData(
      "application/agent-world-template",
      JSON.stringify(template),
    );
    event.dataTransfer.effectAllowed = "move";
  };

  return (
    <div className="absolute top-4 right-4 z-10 bg-surface-light/60 backdrop-blur-sm rounded-lg p-3 w-52 border border-border-subtle/20">
      <div className="text-xs text-text-muted font-medium mb-3">
        Agent Palette
      </div>
      <div className="space-y-1">
        {AGENT_TEMPLATES.map((template) => (
          <div
            key={template.backend}
            draggable
            onDragStart={(e) => onDragStart(e, template)}
            className={`border-l-2 ${template.color} rounded-lg px-3 py-2 cursor-grab active:cursor-grabbing hover:bg-surface-lighter/30 transition-colors duration-200`}
          >
            <div className="text-xs font-medium text-text-primary">
              {template.label}
            </div>
            <div className="text-[11px] text-text-muted mt-0.5">
              {template.description}
            </div>
          </div>
        ))}
      </div>
      <div className="mt-3 text-[11px] text-text-muted">
        Drag an agent onto the canvas
      </div>
    </div>
  );
}
